/* eslint-disable no-unused-vars */

import React from 'react';
import { Route, Link, Redirect, BrowserRouter as Router, Switch } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as rb from 'react-bootstrap';

import SlideInContent from './SlideInContent';

class Header extends React.Component {
    constructor(props) {
        super();
        this.state = {
            apiUrl: window.$apiUrl,
            scrolled: true,
            aboutPanel: false,
            isChallenge:"",
            navExpanded: false
        };
        this.setNavExpanded = this.setNavExpanded.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
        this.toggleAbout = this.toggleAbout.bind(this);
    }

    setNavExpanded(expanded) {
        this.setState({ navExpanded: expanded });
    }

    toggleMenu(){
        this.setState({ navExpanded: false });
    }

    toggleAbout(){
        this.setState({aboutPanel : !this.state.aboutPanel, navExpanded: false});
    }

    getLatestChallenge() {
        fetch(this.state.apiUrl + '/ChallengeAPI/GetLatestChallenge', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            }
        })
            .then(res => res.json())
            .then((data) => {
                //if (data.Status === 'OK') {
                this.setState({ isChallenge: data.Status });
                //}
            })
            .catch(console.log);
    }

    componentDidMount() {
        this.prev = window.scrollY;
        this.getLatestChallenge();
        window.addEventListener('scroll', e => this.handleNavigation(e));
    }

    handleNavigation = (e) => {
        // const window = e.currentTarget;
        this.setState({ navExpanded: false });
        // if (this.prev > window.scrollY) {
        //     this.setState({ scrolled: true });
        // } else if (this.prev < window.scrollY) {
        //     this.setState({ scrolled: false });
        // }
        // this.prev = window.scrollY;

    };

    render() {
        let display_Header = this.state.scrolled ? 0 : '-120px';
        return (
            <div>
                <div id="Header" className="Header position-fixed" style={{ top: display_Header }}>
                    <div className="container-fluid bg-gov-tagLine">
                        <div className="row">
                            <div className="col-md-12 d-flex align-items-center">
                                <a target="_blank" href="http://gov.sg">
                                    <img src="images/singgov.svg" alt="" className="icons-xs" />&nbsp;
                                    <small className="text-dark">A Singapore Government Agency Website</small>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid container-header w-100 py-1">
                        <div className="row">
                            <div className="col-md-12 p-0">
                                <rb.Navbar bg="white" expand="lg" onToggle={this.setNavExpanded} expanded={this.state.navExpanded}>
                                    <rb.Navbar.Brand as={Link} to="/"><img src="images/logo.png" className="logo_dimension logo" alt="" /></rb.Navbar.Brand>
                                    <rb.Navbar.Toggle aria-controls="basic-rb.Navbar-nav" />
                                    <rb.Navbar.Collapse id="basic-rb.Navbar-nav">
                                        <rb.Nav className="mr-auto">
                                            <rb.Nav.Link onClick={this.toggleAbout}>ABOUT YEP</rb.Nav.Link>
                                            <rb.Nav.Link onClick={this.toggleMenu} as={Link} to="/stories">OUR STORIES</rb.Nav.Link>
                                            <rb.Nav.Link onClick={this.toggleMenu} as={Link} to="/challenge">CHALLENGE</rb.Nav.Link>
                                            <rb.Nav.Link onClick={this.toggleMenu} as={Link}  to="/customlayout"><span className="p-1 font-CaveatBrush btn-submitStory" style={{border:'1px solid #E31837', borderRadius:'5px'}}>SUBMIT STORY</span></rb.Nav.Link>
                                        </rb.Nav>
                                    </rb.Navbar.Collapse>
                                </rb.Navbar>
                            </div>
                        </div>
                    </div>

                </div>
                <SlideInContent hideShow={this.state.aboutPanel} parentMethod={this.toggleAbout}  />
            </div>

        );
    }
}
export default Header;
